import { useState } from 'react';
import CreatePaymentReceivedHeader from './createPaymentReceivedHeader';
import { getCurrentDate } from '../../../../../utils/dateUtils';
import PaymentReceivedForm from './paymentReceivedForm';
import { useBlocker, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
	createPaymentsReceived,
	updatePaymentsReceived,
} from '../../../../../services/payments_received';
import ExcessPaymentModal from '../components/excessPaymentModal';
import AutoSaveModal from '../../../../components/autoSaveModal';
import { useSelector } from 'react-redux';

const CreatePaymentReceived = () => {
	const [error, setError] = useState({});
	const [tableError, setTableError] = useState([]);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const param = useParams();
	const id = param?.id;
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const [loading, setLoading] = useState(false);
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isPaymentReceivedAutoSave, setIsPaymentReceivedAutoSave] = useState(false);
	const [isExcessPaymentModalOpen, setIsExcessPaymentModalOpen] = useState(false);
	const [paymentReceived, setPaymentRecieved] = useState({
		customer_id: null,
		payment_receive_number: null,
		date: getCurrentDate(),
		received_payment_amount: null,
		deposit_to_id: 1,
		notes: '',
		payment_method: null,
	});
	const [paymentReceivedTable, setPaymentReceivedTable] = useState([]);
	const handlePaymentChange = (index, value) => {
		const paymentBillsData = [...paymentReceivedTable];
		paymentBillsData[index].payment_amount = value;
		setPaymentReceivedTable(paymentBillsData);
		const isValid = Number(paymentBillsData[index].due_amount) >= Number(value);
		setTableError((prev) => {
			const filtered = prev.filter((error) => error.index !== index);

			return isValid ? filtered : [...filtered, { index, error: 'Invalid Payment' }];
		});
	};
	const handleFullPaymentToggle = (index, type) => {
		if (type === 'pay') {
			if (Number(paymentReceived?.received_payment_amount || 0) > 0) {
				const paymentAmount = paymentReceivedTable?.reduce(
					(total, bill) => Number(total) + Number(bill.payment_amount),
					0,
				);
				if (
					Number(paymentReceived?.received_payment_amount) - Number(paymentAmount) >
					Number(paymentReceivedTable[index].due_amount)
				) {
					const paymentBillsData = [...paymentReceivedTable];
					paymentBillsData[index].payment_amount = paymentBillsData[index].due_amount;
					setPaymentReceivedTable(paymentBillsData);
				} else {
					const paymentBillsData = [...paymentReceivedTable];
					paymentBillsData[index].payment_amount =
						Number(paymentReceived?.received_payment_amount) - Number(paymentAmount);
					setPaymentReceivedTable(paymentBillsData);
				}
			} else {
				var newError = { ...error };
				newError.received_payment_amount = 'Please enter payment received amount in the field';
				setError(newError);
			}
		} else {
			const paymentBillsData = [...paymentReceivedTable];
			paymentBillsData[index].payment_amount = 0.0;
			setPaymentReceivedTable(paymentBillsData);
		}
	};

	const calculateTotalPayment = () => {
		return paymentReceivedTable?.reduce(
			(total, bill) => Number(total) + Number(bill.payment_amount),
			0,
		);
	};

	const calculateTotalExcessPayment = () => {
		const paymentAmount = paymentReceivedTable?.reduce(
			(total, bill) => Number(total) + Number(bill.payment_amount),
			0,
		);

		return Number(paymentReceived?.received_payment_amount ?? 0) - Number(paymentAmount);
	};

	function handleClearAppliedAmount() {
		const paymentBillsData = paymentReceivedTable.map((item) => ({
			...item,
			payment_amount: '',
		}));
		setPaymentReceivedTable(paymentBillsData);
	}

	const checkValidation = (status) => {
		let newError = { ...error };
		let newTableError = [...tableError];
		if (
			!paymentReceived.customer_id ||
			paymentReceived.customer_id === '' ||
			paymentReceived.customer_id === undefined
		) {
			newError.customer_id = 'Please select a valid customer from the list.';
		} else {
			delete newError.customer_id;
		}

		if (
			!paymentReceived.payment_receive_number ||
			paymentReceived.payment_receive_number === '' ||
			paymentReceived.payment_receive_number === undefined
		) {
			newError.payment_receive_number = 'Please enter payment receive number in the field';
		} else {
			delete newError.payment_receive_number;
		}

		if (
			!paymentReceived.date ||
			paymentReceived.date === '' ||
			paymentReceived.date === undefined ||
			(paymentReceived.date !== '' && newError.date)
		) {
			newError.date = newError.date ?? 'Please enter payment date in the field';
		} else {
			delete newError.date;
		}

		if (
			!paymentReceived.payment_method ||
			paymentReceived.payment_method === '' ||
			paymentReceived.payment_method === undefined
		) {
			newError.payment_method = 'Please select a valid payment method from the list.';
		} else {
			delete newError.payment_method;
		}

		if (
			!paymentReceived.received_payment_amount ||
			paymentReceived.received_payment_amount === '' ||
			paymentReceived.received_payment_amount === undefined ||
			(paymentReceived.received_payment_amount !== '' && newError.received_payment_amount)
		) {
			newError.received_payment_amount = 'Please enter payment receive amount in the field';
		} else {
			delete newError.received_payment_amount;
		}

		if (
			Object.keys(newError).length > 0 ||
			newTableError.length > 0 ||
			calculateTotalExcessPayment() < 0
		) {
			setError(newError);
			setTableError(newTableError);
			return true;
		} else {
			return false;
		}
	};

	const handleSubmitPaymentReceived = async (status, isCreditNote = false) => {
		const isErrorShow = checkValidation(status);
		if (isErrorShow) {
			if (calculateTotalExcessPayment() < 0) {
				toast.error('Payment Amount should not greater than amount received.');
			} else {
				toast.error('Please fill all mandatory fields before saving');
			}
		} else {
			try {
				setLoading(true);
				const body = {
					customer_id: paymentReceived?.customer_id,
					payment_receive_number: paymentReceived?.payment_receive_number,
					date: paymentReceived?.date,
					payment_mode_id: paymentReceived?.payment_method,
					received_payment_amount: paymentReceived?.received_payment_amount,
					deposit_to_id: 1,
					notes: paymentReceived?.notes,
					status: status,
					used_payment_amount: calculateTotalPayment().toFixed(2),
					excess_payment_amount: calculateTotalExcessPayment().toFixed(2),
					sales_payment_receives_invoices: paymentReceivedTable,
				};
				if (id) {
					var res = await updatePaymentsReceived(id, body);
					if (res?.success) {
						toast.success('Payment received updated Successfully');
						navigate(`/user/${suburl}/payments-received`);
					} else {
						toast.error(res.message ?? 'something went wrong');
					}
				} else {
					const res = await createPaymentsReceived(body);
					if (res?.success) {
						toast.success('Payment Received Created Successfully');
						setIsLocationBlocker(false);
						setIsPaymentReceivedAutoSave(false);
						setTimeout(() => {
							navigate(`/user/${suburl}/payments-received`);
						}, 300);
					} else {
						toast.error(res.message ?? 'something went wrong');
					}
				}
			} catch (error) {
				toast.error(error.message ?? 'something went wrong');
			} finally {
				setLoading(false);
			}
		}
	};

	useBlocker((tx) => {
		if (!id && isLocationBlocker) {
			setIsNextLocation(tx);
			setIsPaymentReceivedAutoSave(true);
			return true;
		}
		return false;
	});

	return (
		<div>
			<CreatePaymentReceivedHeader
				loadin={loading}
				user={user}
				setIsPaymentReceivedAutoSave={setIsPaymentReceivedAutoSave}
				setIsExcessPaymentModalOpen={setIsExcessPaymentModalOpen}
				handleSubmitPaymentReceived={handleSubmitPaymentReceived}
				calculateTotalExcessPayment={calculateTotalExcessPayment}
			/>
			<PaymentReceivedForm
				paymentReceived={paymentReceived}
				error={error}
				setError={setError}
				setPaymentReceived={setPaymentRecieved}
				setPaymentReceivedTable={setPaymentReceivedTable}
				paymentsReceivedTable={paymentReceivedTable}
				setTableError={setTableError}
				calculateTotalPayment={calculateTotalPayment}
				tableError={tableError}
			/>
			<div
				style={{ padding: '1rem 2rem 0' }}
				className="max-w-1297"
			>
				<div
					style={{
						padding: '10px 0px',
						float: 'right',
						margin: '10px 0px',
					}}
				>
					<div
						className="d-flex"
						style={{ justifyContent: 'flex-end' }}
					>
						<div style={{ color: '#000000', fontWeight: '600', textAlign: 'right' }}>
							<p>Amount Received</p>
							<p>Amount Used For Payment</p>
							<p
								style={{
									display: 'flex',
									textAlign: 'right',
									justifyContent: 'flex-end',
									aliginItems: 'center',
									gap: '5px',
								}}
							>
								<svg
									width="18"
									height="18"
									viewBox="0 0 18 18"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M7.71758 2.89393L1.36508 13.4989C1.2341 13.7258 1.1648 13.9829 1.16407 14.2448C1.16334 14.5067 1.23119 14.7643 1.3609 14.9918C1.4906 15.2194 1.67762 15.409 1.90336 15.5418C2.12909 15.6746 2.38568 15.7461 2.64758 15.7489H15.3526C15.6145 15.7461 15.8711 15.6746 16.0968 15.5418C16.3225 15.409 16.5096 15.2194 16.6393 14.9918C16.769 14.7643 16.8368 14.5067 16.8361 14.2448C16.8354 13.9829 16.7661 13.7258 16.6351 13.4989L10.2826 2.89393C10.1489 2.67351 9.96062 2.49127 9.73597 2.3648C9.51133 2.23832 9.25788 2.17188 9.00008 2.17188C8.74228 2.17188 8.48882 2.23832 8.26418 2.3648C8.03954 2.49127 7.85128 2.67351 7.71758 2.89393Z"
										stroke="#BF9A18"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M9 6.75V9.75"
										stroke="#BF9A18"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M9 12.75H9.0075"
										stroke="#BF9A18"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
								Amount Excess
							</p>
						</div>
						<div style={{ marginLeft: '35px', fontWeight: '600' }}>
							<p>₹ {Number(paymentReceived?.received_payment_amount ?? 0).toFixed(2)}/-</p>
							<p>₹ {calculateTotalPayment()?.toFixed(2) || 'N/A'}/-</p>
							<p>₹ {calculateTotalExcessPayment()?.toFixed(2) || 'N/A'}/-</p>
						</div>
					</div>
				</div>
				<div style={{ clear: 'both' }}></div>
			</div>
			{isExcessPaymentModalOpen && (
				<ExcessPaymentModal
					isModalOpen={isExcessPaymentModalOpen}
					setIsModelOpen={setIsExcessPaymentModalOpen}
					handleCreditNote={() => handleSubmitPaymentReceived(2, true)}
					handlePaymentReceived={() => handleSubmitPaymentReceived(1, false)}
					handleLater={() => handleSubmitPaymentReceived(0, false)}
					excessAmount={calculateTotalExcessPayment().toFixed(2)}
				/>
			)}
			{isPaymentReceivedAutoSave && (
				<AutoSaveModal
					isOpenModel={isPaymentReceivedAutoSave}
					setIsOpenModel={setIsPaymentReceivedAutoSave}
					user={user}
					permission={'sales.payments_received.create'}
					type={'Payment Received'}
					withoutSave={() => {
						setIsLocationBlocker(false);
						setIsPaymentReceivedAutoSave(false);
						setTimeout(() => {
							navigate(isNextLocation.nextLocation?.pathname);
						}, 300);
					}}
					SaveAsContinue={() => {
						setIsPaymentReceivedAutoSave(false);
						handleSubmitPaymentReceived(1);
					}}
				/>
			)}
		</div>
	);
};
export default CreatePaymentReceived;
